export enum archeryCoilderTag{
    arrow,
    enemy,
    friend
}
